import React from "react";
import blackEmbeddingIcon from "../../assets/images/blackembeddingicon.svg";
import redEmbeddingIcon from "../../assets/images/redembeddingicon.svg";

const EmbeddingStatusIcon = ({
  embeddingStatus,
  onClick,
  disabled = false,
  tooltip,
  className = "",
}) => {
  if (!embeddingStatus || embeddingStatus === "none") {
    return null;
  }

  const isSynced = embeddingStatus === "synced";
  const iconSrc = isSynced ? blackEmbeddingIcon : redEmbeddingIcon;

  return (
    <span
      className={`catalog-embedding-icon${tooltip ? " tooltip-area-up" : ""} ${className}`.trim()}
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled || !onClick ? "default" : "pointer",
        opacity: disabled ? 0.5 : 1,
        display: "inline-flex",
        lineHeight: 0,
      }}
      role={onClick ? "button" : undefined}
      tabIndex={onClick && !disabled ? 0 : undefined}
      onKeyDown={
        onClick && !disabled
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
    >
      <img src={iconSrc} width={24} height={24} alt="" aria-hidden="true" />
      {tooltip ? (
        <span
          className="tooltip-area-up-text catalog-embedding-icon__tooltip"
          style={{ backgroundColor: "#5CC7C1", marginBottom: "5px" }}
        >
          {tooltip}
        </span>
      ) : null}
    </span>
  );
};

export const hasEmbeddingStatusIcon = (embeddingStatus) =>
  Boolean(embeddingStatus && embeddingStatus !== "none");

export const getEmbeddingTooltip = (embeddingStatus, t) => {
  if (embeddingStatus === "stale") {
    return t(
      "This product changed since it was embedded. Re-run embedding to update search results."
    );
  }
  if (embeddingStatus === "none") {
    return t("Never embedded. Re-run embedding to include in search.");
  }
  return t("Embedded and up to date");
};

export default EmbeddingStatusIcon;
